import React from 'react';
import './DetailsCard.css';
import PercentageChart from './PercentageChart.js';

const DetailsCard = ({ data, score }) => {
  // Calculate year from ProjectId if available
  const projectYear = data?.ProjectId ? data.ProjectId.substring(0, 4) : 'N/A';
  
  // Convert score to percentage (0-1 to 0-100)
  const matchPercentage = (score || 0) * 100;

  return (
    <div className="project-box shadow-lg container">
      <div className="row">
        {/* Project Details Section */}
        <div className="col-md-8 project-details">
          <div className="detail-item">
            <h5 className="text-start m-1 p-2">
              <strong>Faculty:</strong> {data?.ProjectSupervisor || 'N/A'}
            </h5>
          </div>
          
          <div className="detail-item">
            <h5 className="text-start m-1 p-2">
              <strong>Project Title:</strong> {data?.ProjectTitle || 'N/A'}
            </h5>
          </div>
          
          <div className="detail-item">
            <h5 className="text-start m-1 p-2">
              <strong>Type:</strong> {data?.Project_Type || 'N/A'}
            </h5>
          </div>
          
          <div className="detail-item">
            <h5 className="text-start m-1 p-2">
              <strong>Department:</strong> {data?.Department || 'N/A'}
            </h5>
          </div>

          {data?.AdditionalInfo?.Domain && (
            <div className="detail-item">
              <h5 className="text-start m-1 p-2">
                <strong>Domain:</strong> {data.AdditionalInfo.Domain}
              </h5>
            </div>
          )}

          <div className="detail-item">
            <h5 className="text-start m-1 p-2">
              <strong>Year:</strong> {projectYear}
            </h5>
          </div>
          
          <div className="detail-item">
            <h5 className="text-start m-1 p-2">
              <strong>Project ID:</strong> {data?.ProjectId || 'N/A'}
            </h5>
          </div>
        </div>

        {/* Chart Section */}
        <div className="col-md-4 chart-container text-center">
          <div className="percentage-chart">
            <PercentageChart percentage={matchPercentage} />
          </div>
          <p className="text-center m-1 p-2">
            <strong>Matching Percentage</strong>
          </p>
        </div>
      </div>
    </div>
  );
};

export default DetailsCard;